var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.864 11.627V20h-3.75v-8.373H0V8.232h3.115V6.997C3.115 2.411 4.982 0 8.934 0c1.21 0 1.514.2 2.177.362V3.72c-.743-.133-.952-.207-1.723-.207-.916 0-1.406.267-1.853.792-.447.525-.67 1.435-.67 2.736V8.24h4.246l-1.14 3.395H6.865v-.008Z",
    fill: "currentColor"
  })));
};
export default SvgFacebook;